<script setup lang="ts">
  import { KsButton } from '@aschehoug/kloss'

  /**
   * Checkout [Kloss Button](https://kloss.aunivers.no/?page=button) for a full list of props.
   */
  const buttonProps = defineProps<{
    variant?: 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'flat-sharp' | 'link'
    size?: 'small' | 'medium' | 'large'
    shape?: 'normal' | 'square' | 'rounded' | 'round'
    stretch?: boolean
    center?: boolean
    raised?: boolean
    disabled?: boolean
    iconLeft?: string
    iconRight?: string
  }>()
</script>

<template>
  <ks-button
    v-bind="buttonProps"
    :class="['vgs-button', shape, variant]"
  >
    <slot />
  </ks-button>
</template>

<style scoped lang="scss">
  .quaternary {
    background-color: initial;
    border: 2px solid var(--color-blue-50);
    color: var(--color-blue-50);

    @include vgs-media-hover {
      background-color: var(--color-blue-50-opacity-05);
    }
  }

  .flat-sharp {
    border: 2px solid var(--color-gray-20);
    background-color: var(--color-white);
    color: var(--color-blue-50);

    --ks-roundness: 0;

    @include vgs-media-hover {
      background-color: var(--color-gray-10);
    }
  }

  .link {
    background: initial;
    border: initial;
    border-bottom: 1px solid var(--color-pair-color, var(--color-white));
    border-radius: initial;
    color: var(--color-pair-color, var(--color-white));
    min-width: unset;
    height: unset;
    padding: 0;

    &:hover {
      border-bottom-color: transparent;
    }
  }
</style>
